import { render, staticRenderFns } from "./regularRoute.vue?vue&type=template&id=857ec200&"
import script from "./regularRoute.vue?vue&type=script&lang=js&"
export * from "./regularRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports